import {Checkbox, FormControlLabel} from "@mui/material";
import {Box} from "@mui/system";

export default function CheckboxLabel({name, checked, value, label, onChange, disabled}) {
    return(
        <Box>
            <FormControlLabel
                name={name}
                checked={checked}
                value={value}
                sx={style.formControlLabel}
                control={<Checkbox/>}
                label={label}
                disabled={disabled}
                onChange={onChange}
            />
        </Box>
    )
}

const style = {
    formControlLabel: {
        ml: '-8px',
        '& .MuiSvgIcon-root': {
            fontSize: '22px',
            color: '#003300',
        },
        '& .MuiButtonBase-root': {
            padding: '5px'
        },
        '& .MuiFormControlLabel-label': {
            fontFamily: 'LarsseitRegular',
            fontSize: '14px',
            color: '#0C2728',
            letterSpacing: '-0.01em',

            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        },
        "& .MuiTouchRipple-child": {
            backgroundColor: '#003300',
        },
    },
}